import moment from 'moment';
import DOMPurify from 'dompurify';

function mostViewSort(data) {
    let initial = 0;
    let secondFirst = Math.floor(data.length / 2) - 1;
    const results = [];
    data.forEach((item, i) => {
        if (i % 2) {
            secondFirst += 1;
            results.push({ ...data[secondFirst], id: secondFirst + 1 });
        } else {
            initial += 1;
            results.push({ ...data[initial], id: initial });
        }
    });
    return results;
}

function formatDate(date) {
    return moment(date).format('LL');
}

function convertHexToRgba(hexColor, opacity) {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function sanitizeHtml(content) {
    return DOMPurify.sanitize(content, {
        ADD_ATTR: ['target', 'rel'],
    });
}

/**
 * Joins the author and company with " / ", skipping empty values.
 */
function formatAuthorWithCompany(author, company) {
    return [author, company].filter(Boolean).join(' / ');
}

export {
    convertHexToRgba,
    formatAuthorWithCompany,
    formatDate,
    mostViewSort,
    sanitizeHtml,
};
